import EIEComingSoon from "../components/EIE/EIEComingSoon";

export default function EIEPage() {
  return (
    <main>
      <EIEComingSoon />
    </main>
  );
}
